import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";

const ShowGeoTubesData = ({ showModal, handleCloseModal, deviceId }) => {
    const [rowDeviceData, setRowDeviceData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (deviceId && showModal) {
                const url = `/api/2.0/waterquality/account/mahakumbh/deviceId/${deviceId}/summary`;
                const headers = {
                    "Ocp-Apim-Subscription-Key": "2293bfaf145a49869f496ecbe4e68948",
                    "Client-Id": "01588577-66dd-4dc8-9ba1-a51e9788171d",
                    "Client-Secret": "zQp8Q~kLdF~jc_~~QRWWICcHpn~nGamcs.-CIdv0",
                    "Content-Type": "application/json",
                };

                try {
                    const response = await fetch(url, { method: "GET", headers });
                    if (!response.ok) {
                        const errorText = await response.text();
                        throw new Error(`HTTP error! Status: ${response.status} - ${errorText}`);
                    }
                    const result = await response.json();
                    setRowDeviceData(result);
                } catch (error) {
                    console.error("Error fetching data:", error.message);
                }
            }
        };

        fetchData();
    }, [deviceId, showModal]);


    return (
        <Modal
            size="lg"
            show={showModal}
            onHide={handleCloseModal}
            className="meeting-modal"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="upload-modal-title" className="text-center" style={{color: '#ed5722'}}>
                    Waste Water Treatment with GeoTubes
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="report-form">

                    {rowDeviceData ? (
                        <>
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-md-6 text-center">
                                    <div className="data-box">
                                        <p>Biochemical Oxygen Demand (BOD)</p>
                                        <hr />
                                        <span>{rowDeviceData[0].bod} mg/L</span>
                                    </div>
                                </div>

                                <div className="col-md-6 text-center">
                                    <div className="data-box">
                                        <p>Chemical Oxygen Demand (COD)</p>
                                        <hr />
                                        <span>{rowDeviceData[0].cod} mg/L</span>
                                    </div>
                                </div>

                                <div className="col-md-6 text-center">
                                    <div className="data-box">
                                        <p>Total Suspended Solids (TSS)</p>
                                        <hr />
                                        <span>{rowDeviceData[0].tss} mg/L</span>
                                    </div>
                                </div>

                                <div className="col-md-6 text-center">
                                    <div className="data-box">
                                        <p>Dissolved oxygen (DO)</p>
                                        <hr />
                                        <span>{rowDeviceData[0].do} mg/L</span>
                                    </div>
                                </div>

                                <div className="col-md-6 text-center">
                                    <div className="data-box">
                                        <p>pH</p>
                                        <hr />
                                        <span>{rowDeviceData[0].ph}</span>
                                    </div>
                                </div>
                            </div>

                        </>

                        // <pre>{JSON.stringify(rowDeviceData, null, 2)}</pre>
                    ) : (
                        <p>Loading data...</p>
                    )}

                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ShowGeoTubesData;
